import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import * as ACL from 'domain/restriction';
import { rtlEnable } from 'domain/env';

import { invertPinnedValue } from 'pages/company/grid/helpers';

import type { TColumnDefs } from 'pages/company/grid/types.js.flow';

const mapPropsToState = (state) => ({
  isGranted: ACL.isGranted(state),
  isRtl: rtlEnable(state),
});

const useAgGridMethods = () => {
  const { isRtl } = useSelector(mapPropsToState);

  const invertedPinnedIfRTL = useCallback(
    (columns: TColumnDefs[]) => (isRtl ? invertPinnedValue(columns) : columns),
    [isRtl],
  );

  return {
    invertedPinnedIfRTL,
  };
};

export default useAgGridMethods;
